import { t } from '@lingui/macro';

import SearchResultCard from '@rover/react-lib/src/components/cards/SearchResultCard';
import type { PriceTransparencyLevel, SearchResult } from '@rover/types';

import SearchSectionHeader, { HeaderIconEnum, HeaderScenariosEnum } from '../SearchSectionHeader';

type Props = {
  displayExpanded: boolean;
  isAuthenticated: boolean | null | undefined;
  language: string;
  memberProfileLinkParams: Record<string, string | undefined>;
  onFavoriteToggled: (personOpk: string) => void;
  searchResults: SearchResult[];
  serviceName: string;
  serviceDescription: string;
  isSeoPage: boolean;
  preferCatReviews: boolean;
  priceTransparencyLevel?: PriceTransparencyLevel;
  showFromText: boolean;
  isShowingPriceInCurrency: boolean;
};

export default ({
  displayExpanded,
  isAuthenticated,
  language,
  memberProfileLinkParams,
  onFavoriteToggled,
  searchResults,
  serviceName,
  serviceDescription,
  isSeoPage,
  preferCatReviews,
  priceTransparencyLevel,
  showFromText,
  isShowingPriceInCurrency,
}: Props): JSX.Element => {
  return (
    <>
      <SearchSectionHeader
        id={HeaderScenariosEnum.LOW_SUPPLY}
        headerIconName={HeaderIconEnum.SEARCH}
        headerText={t({
          message: `Sitters who offer ${serviceName}`,
          comment: '{serviceName} e.g. Drop-in Visits',
        })}
        primarySubheaderText={serviceDescription}
      />
      {searchResults.map((searchResult: SearchResult, i: number) => (
        <SearchResultCard
          displayExpanded={displayExpanded}
          index={i}
          isAuthenticated={isAuthenticated}
          key={`alternate-${
            searchResult.isFacility ? searchResult.facilityOpk : searchResult.personOpk
          }`}
          isAlternateResult
          language={language}
          memberProfileLinkParams={memberProfileLinkParams}
          onFavoriteToggled={() => onFavoriteToggled(searchResult.personOpk)}
          searchResult={searchResult}
          isSeoPage={isSeoPage}
          preferCatReviews={preferCatReviews}
          priceTransparencyLevel={priceTransparencyLevel}
          fromAlternateSearchResults
          showFromText={showFromText}
          isShowingPriceInCurrency={isShowingPriceInCurrency}
        />
      ))}
    </>
  );
};
